require("@rails/ujs").start()
require("@rails/activestorage").start()

const images = require.context('../img', true)
const imagePath = (name) => images(name, true)

import '../stylesheets/login_layout'
import '../stylesheets/custom'
import 'bootstrap'
import '@fortawesome/fontawesome-free/js/all.js'